<div [style.display]="isVisible() ? 'block' : 'none'" class="checkbox-item-wrapper">
  <div class="checkbox-wrapper">
    <input type="checkbox" [id]="htmlId()" [formControl]="formControl!" (change)="onCheckboxChanged($event)" />
    <label
      [for]="htmlId()"
      class="value preserve-newlines"
      [class.label-disabled]="formControl?.disabled"
      [ngClass]="properties.style.toLowerCase() || ''"
      [style]="textStyle()">
      {{ properties.text.trim() }}
    </label>
  </div>
</div>
